const requesObj = {}
requesObj.requestUrl = process.env.API_ROOT + '' //  记得修改 WebSocket 的地址
export default requesObj



// WEBPACK FOOTER //
// ./src/script/publicUrl.js